module.exports = __webpack_public_path__ + "static/media/profile_image_placeholder_jenny.afff988c.jpg";